/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Metadata_Merge_Notes_CheckInputs */



/**
* | output |
* | --- |
* | "Notes Check" |
*
* @param {Metadata_Merge_Notes_CheckInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const metadata_merge_notes_check = /** @type {((inputs?: Metadata_Merge_Notes_CheckInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Metadata_Merge_Notes_CheckInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vérification des notes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Notizen geprüft")
	if (locale === "it") return /** @type {LocalizedString} */ ("Controllo note")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Проверка заметок")
	if (locale === "es") return /** @type {LocalizedString} */ ("Comprobación de notas")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("笔记检查")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ノート確認")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नोट्स जाँच")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Verificação de notas")
	return /** @type {LocalizedString} */ ("Notes Check")
});